
export const SupplierRegistration = () => {

    return (
        <>
            <div>Hola</div>
        </>
    )
}